import React from "react";
import { toast } from "react-toastify";
import {Navbar, Container, Nav, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, Media, NavItem,
    NavLink, NavbarBrand, Collapse, UncontrolledCollapse
} from "reactstrap";
import { Link, NavLink as NavLinkRRD } from "react-router-dom";
import {connect} from "react-redux";

class Sidebar extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            collapseOpen: false
        }
    }

    // toggles collapse between opened and closed (true/false)
    toggleCollapse = () => {
        this.setState({
        collapseOpen: !this.state.collapseOpen
        })
    };

    // closes the collapse
    closeCollapse = () => {
        this.setState({
        collapseOpen: false
        });
    };

    // creates the links that appear in the left menu / Sidebar
    createLinks = (routes,parent_layout) => {
        return routes.map((prop, key) => {
            if(prop.name == 'Profile'){
                return null;
            }

            if(prop.show == false){
                return null;
            }

            if(!prop.isTitle){
                
                if(prop.child == null){
                    if(prop.isSubMenu){
                        return (
                            <NavItem key={parent_layout+key}>
                                <NavLink
                                    to={parent_layout+prop.layout + prop.path}
                                    tag={NavLinkRRD}
                                    onClick={this.closeCollapse}
                                    activeClassName="active"
                                >   
                                    <span className="ml-5"></span>
                                    {prop.name}
                                </NavLink>
                            </NavItem>
                        )
                    } else {
                        return (
                            <NavItem key={parent_layout+key}>
                                <NavLink
                                    to={parent_layout+prop.layout + prop.path}
                                    tag={NavLinkRRD}
                                    onClick={this.closeCollapse}
                                    activeClassName="active"
                                >
                                    <i className={'sidebarIcon ' + prop.icon} />
                                    {prop.name}
                                </NavLink>
                            </NavItem>
                        );
                    }
                } else {
                    return (
                        <NavItem key={key}>
                          <NavLink
                            id={prop.id}
                            style={{cursor:'pointer'}}
                          >
                            <i className={'sidebarIcon ' + prop.icon} />
                            {prop.name}
                          </NavLink>
                          <UncontrolledCollapse toggler={'#'+prop.id} >
                            <ul className="nav submenu">
                              {this.createLinks(prop.child,prop.layout)}
                            </ul>
                          </UncontrolledCollapse>
                        </NavItem>
                    );
                }
            } else {
                return (
                    <NavItem key={key} style={{paddingLeft: 25}} className="header-menu">
                        <h3 style={{color: '#fff'}}>{prop.name}</h3>
                    </NavItem>
                    
                )
            }
        });
    };

    render() {
        const {routes, logo} = this.props;
        let navbarBrandProps;
        if (logo && logo.innerLink) {
            navbarBrandProps = {
                to: logo.innerLink,
                tag: Link
            };
        } else if (logo && logo.outterLink) {
            navbarBrandProps = {
                href: logo.outterLink,
                target: "_blank"
            };
        }
        return(
            <Navbar className="sidebar-main navbar-vertical fixed-left navbar-light bg-white" expand="md" id="sidenav-main">
                <Container fluid>
                    {/* Toggler */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={this.toggleCollapse}
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    {/* Brand */}
                    {logo ? (
                        <NavbarBrand className="pt-0" {...navbarBrandProps}>
                            <span style={{color: '#fff'}}>Murettebat®</span>
                        </NavbarBrand>
                    ) : null}
                    
                    {/* Collapse */}
                    <Collapse navbar isOpen={this.state.collapseOpen}>
                        {/* Navigation */}
                        <Nav navbar>{this.createLinks(routes, '')}</Nav>
                    </Collapse>

                </Container>
            </Navbar>
        )
    }
}

export default Sidebar;
// const mapStateToProps = (state) =>({
//   ...state
// })

// const mapDispatchToProps = (dispatch) =>({

// })

// export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
